export const isConfirming = (x) => {
    return x.sourceTxConfs !== undefined;
};
export const isAccepted = (x) => {
    return x.renSignature !== undefined;
};
export const isSubmitted = (x) => {
    return x.contractParams !== undefined;
};
export const isMinted = (x) => {
    return x.destTxHash !== undefined;
};
export const isCompleted = (x) => {
    return x.completedAt !== undefined;
};
export const isErroring = (x) => {
    return x.error !== undefined;
};
export const isOpen = (x) => {
    return x.gatewayAddress !== undefined;
};
//# sourceMappingURL=mint.js.map